import * as React from 'react';
export const rateCardSvg = React.forwardRef(function rateCardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13 0a2 2 0 0 1 2 2v12a2 2 0 0 1-1.796 1.99L13 16H3l-.204-.01A2 2 0 0 1 1 14V2a2 2 0 0 1 2-2h10ZM7 14.5h6a.5.5 0 0 0 .5-.5v-3H7v3.5ZM2.5 14a.5.5 0 0 0 .5.5h2.5V11h-3v3ZM7 9.5h6.5V6H7v3.5Zm-4.5 0h3V6h-3v3.5Zm4.5-5h6.5V2a.5.5 0 0 0-.5-.5H7v3Zm-4-3a.5.5 0 0 0-.5.5v2.5h3v-3H3Z',
    }),
  );
});
rateCardSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rateCard = {
  category: 'icon',
  colorable: true,
  name: 'rateCard',
  svg: rateCardSvg,
};
